import { Injectable } from '@angular/core';
import { HttpBackend } from '@angular/common/http';
import { CfgService } from '../../cfg/cfg.service';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class SigV4Cfg {
  public accessKey: string;
  public endpoint: string;
}

@Injectable({
  providedIn: 'root'
})
export class SigV4CfgService extends CfgService<SigV4Cfg> {
  json: any = {
    accessKey: "%{AccessKeySignV4}",
    endpoint: "%{NotificationHubApi}/sigv4/signkey?accessKey={0}&date={1}&region={2}&service={3}"
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/sigv4.cfg.json`;
  }

  /**
  * Carga las url en el json
  */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
